<template>
  <div>
    <el-group-title title="分包合同">
      <template slot="groupTitle">
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="163px"
          class="ccui-form demo-form-inline"
          :inline="true"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="合同类型：" prop="subContractType">
                <el-input
                  v-model="form.subContractType"
                  class="ccui-form-longInput"
                  placeholder="请输入合同类型"
                  clearable
                  maxlength="10"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="分包专业名称：" prop="subcontractName">
                <el-input
                  v-model="form.subcontractName"
                  class="ccui-form-longInput"
                  placeholder="请输入分包专业名称"
                  clearable
                  maxlength="2"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="分包专业编码：" prop="subcontractCode">
                <el-input
                  v-model="form.subcontractCode"
                  class="ccui-form-longInput"
                  placeholder="请输入分包专业编码"
                  clearable
                  maxlength="2"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="标包名称(预留)：" prop="bindingName">
                <el-input
                  v-model="form.bindingName"
                  class="ccui-form-longInput"
                  placeholder="请输入标包名称(预留)"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="标包类型值：" prop="bindingTypeValue">
                <el-input
                  v-model="form.bindingTypeValue"
                  class="ccui-form-longInput"
                  placeholder="请输入标包类型值"
                  clearable
                  maxlength="20"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="标包类型：" prop="bindingType">
                <el-input
                  v-model="form.bindingType"
                  class="ccui-form-longInput"
                  placeholder="请输入标包类型"
                  clearable
                  maxlength="2"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="招标时间：" prop="bindingDate">
                <el-date-picker
                  v-model="form.bindingDate"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="定标时间：" prop="scalingDate">
                <el-date-picker
                  v-model="form.scalingDate"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="履约保证金：" prop="performanceBondAmt">
                <el-input
                  v-model="form.performanceBondAmt"
                  class="ccui-form-longInput"
                  placeholder="请输入履约保证金"
                  clearable
                  maxlength="12"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="保证金比例(%)：" prop="performanceBondRate">
                <el-input
                  v-model="form.performanceBondRate"
                  class="ccui-form-longInput"
                  placeholder="请输入保证金比例(%)"
                  clearable
                  maxlength="4"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="保证金到期时间：" prop="expirationTime">
                <el-date-picker
                  v-model="form.expirationTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="是否应现金缴纳：" prop="isPayCash">
                <el-select
                  v-model="form.isPayCash"
                  class="ccui-form-longInput"
                  placeholder="请选择是否应现金缴纳"
                >
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="是否已现金缴纳：" prop="isPaidCash">
                <el-select
                  v-model="form.isPaidCash"
                  class="ccui-form-longInput"
                  placeholder="请选择是否已现金缴纳"
                >
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="合同开工日期：" prop="commencementDate">
                <el-date-picker
                  v-model="form.commencementDate"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="合同完工日期：" prop="completedDate">
                <el-date-picker
                  v-model="form.completedDate"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="工期：" prop="timeLimit">
                <el-input
                  v-model="form.timeLimit"
                  class="ccui-form-longInput"
                  placeholder="请输入工期"
                  clearable
                  maxlength=""
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="乙方现场委托人：" prop="partyBPerson">
                <el-input
                  v-model="form.partyBPerson"
                  class="ccui-form-longInput"
                  placeholder="请输入乙方现场委托人"
                  clearable
                  maxlength="50"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                label="乙方现场委托人身份证号码："
                prop="partyBPersonNo"
                class="ccui-pre-form-item"
              >
                <el-input
                  v-model="form.partyBPersonNo"
                  class="ccui-form-longInput"
                  placeholder="请输入乙方现场委托人身份证号码"
                  clearable
                  maxlength="20"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="乙方现场委托人电话：" prop="partyBPersonTel">
                <el-input
                  v-model="form.partyBPersonTel"
                  class="ccui-form-longInput"
                  placeholder="请输入乙方现场委托人电话"
                  clearable
                  maxlength="20"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="合同推送状态：" prop="contractPushStatus">
                <el-input
                  v-model="form.contractPushStatus"
                  class="ccui-form-longInput"
                  placeholder="请输入合同推送状态"
                  clearable
                  maxlength="20"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </el-group-title>
  </div>
</template>

<script>
export default {
  name: "pcConcSub",
  data() {
    return {
      form: {
        id: "",
        subContractType: "",
        subcontractName: "",
        subcontractCode: "",
        bindingName: "",
        bindingTypeValue: "",
        bindingType: "",
        bindingDate: "",
        scalingDate: "",
        performanceBondAmt: "",
        performanceBondRate: "",
        expirationTime: "",
        isPayCash: "",
        isPaidCash: "",
        commencementDate: "",
        completedDate: "",
        timeLimit: "",
        partyBPerson: "",
        partyBPersonNo: "",
        partyBPersonTel: "",
        contractPushStatus: "",
        tPcConcId: ""
      },
      rules: {}
    };
  }
};
</script>
